import {
  getResponsiveColorPropControllerDataResponsiveColorData
} from "@makeswift/prop-controllers";
import { useResponsiveColor } from "./useResponsiveColor";
function useResponsiveColorPropControllerData(data) {
  const responsiveColorData = data == null ? data : getResponsiveColorPropControllerDataResponsiveColorData(data);
  return useResponsiveColor(responsiveColorData);
}
export {
  useResponsiveColorPropControllerData
};
//# sourceMappingURL=useResponsiveColorPropControllerData.js.map